import Store from 'redux/store';
import {
  FETCH_AUTOCOMPLETE,
  FETCH_AUTOCOMPLETE_FAIL,
  FETCH_AUTOCOMPLETE_SUCCESS,
} from 'redux/Reducers/Autocomplete';
import { cloudloyalty } from '../clients';

/* eslint-disable */
const FetchAutoComplete = async (User, finallyCallback = () => { }, { term }) => {
  Store.dispatch({ type: FETCH_AUTOCOMPLETE });
  cloudloyalty(User).get(`/v2/products/autocomplete?term=${term}`).then((response) => {
    Store.dispatch({
      type: FETCH_AUTOCOMPLETE_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_AUTOCOMPLETE_FAIL,
      error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};
export default FetchAutoComplete;
